import * as S from './CreateTest.styled';

const Tab = () => (
  <div>
    <S.TabText>Test created successfully</S.TabText>
  </div>
);

export default Tab;
